import React, { useState, useEffect, use } from 'react'
import { BasicSelect } from './CustomSelectBox'
import Loader from '../../../../presentationals/Loader/Loader.component'
import TextField from '@mui/material/TextField';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Pagination from '@mui/material/Pagination';
import DeleteIcon from '@mui/icons-material/Delete';
import { GetEmployeeToRule, GetEmployeeToRuleByEmployeeId, DeleteEmployeeToRuleById, getAllrulesList, SaveEmployeetoRule } from './ActionCreator';
import ConfirmationPopup from '../../../../presentationals/Popup/ConfirmationPopup.component';
import Popup from '../../../../presentationals/Popup/Popup.component'
import { APIS } from '../../../../../utils/api-factory';
import InfoIcon from '@mui/icons-material/Info';
import styled from "@emotion/styled";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { saveAssignByStatusAPINew } from '../../AdminActionCreator.component';

const statusObj = [
  { name: "Complete", value: "complete" },
  { name: "Incomplete", value: "incomplete" },
  { name: "Repeat", value: "repeat" },
  { name: "Operations", value: "legal" },
]

const zindex = {
  zIndex: '2'
}

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: '2rem',
  },
}));

const itemsPerPage = 10;
export default function AssignedRulesMain({ admin }) {
  const [loader, setLoader] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [apiData, setApiData] = useState([])
  const [FilterData, setFilterData] = useState([])
  const [currentPage, setcurrentPage] = useState(1)
  const [confirmPopup, setconfirmPopup] = useState({ show: false, data: {} })
  const [popup, setpopup] = useState({ show: false, popupStatus: {} })
  const [addPopup, setAddPopup] = useState(false);
  const [agentType, setagentType] = useState("");
  const [agentsList, setagentsList] = useState([]);
  const [RulesList, setRulesList] = useState([]);
  const [RuleType, setRuleType] = useState("");
  const [allcreatedRules, setallcreatedRules] = useState([])
  const [addUserPopup, setAddUserPopup] = useState(false);
  const [Employeestatus, setEmployeestatus] = useState("");
  const [employeeEmailId, setemployeeEmailId] = useState("");

  const handlesearchchange = (e) => {
    setSearchValue(e.target.value)
    if (e.target.value?.length == 0) {
      GetEmployeeToRuleFn()
    }
  }

  useEffect(() => {
    GetEmployeeToRuleFn()
    getRoleAssignViewFn()
    getAllrulesListFn()
  }, [])

  const getRoleAssignViewFn = () => {
    setLoader(true)
    fetch(APIS.GET_ASSIGN_BY_STATUS)
      .then(res => res.json())
      .then(res => {
        console.log(res)
        if (Array.isArray(res) && res.length > 0) {
          const uniqueMap = new Map();

          res.forEach(item => {
            if (item?.emailId && !uniqueMap.has(item.emailId)) {
              uniqueMap.set(item.emailId, { name: item.emailId, value: item.emailId });
            }
          });

          const newar = Array.from(uniqueMap.values());
          setagentsList(newar);
        } else {
          setagentsList([]);
        }

      })
      .finally(() => {
        setLoader(false)
      })

  }
  const getAllrulesListFn = () => {
    setLoader(true)
    getAllrulesList(callback => {
      setLoader(false)
      console.log("callback-riless", callback)
      if (callback && callback?.length > 0) {
        const newar = callback?.map((Value, id) => {
          return { name: Value?.ruleId, value: Value?.ruleId };
        })
        setallcreatedRules(callback)
        setRulesList(newar)
      } else {
        setRulesList([])
      }
    })
  }

  const GetEmployeeToRuleFn = () => {
    setLoader(true)
    GetEmployeeToRule(callback => {
      setLoader(false)
      setApiData(callback)
      setcurrentPage(1)
      filterFunction(callback, 1)
    })
  }

  const filterFunction = (data, currentPageNo) => {
    const indexOfLastItem = currentPageNo * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data && data?.length > 0 ? data?.slice(indexOfFirstItem, indexOfLastItem) : [];
    setFilterData(currentItems)
  }

  const handlePageChange = (event, value) => {
    setcurrentPage(value);
    filterFunction(apiData, value)
  };

  const handlesearch = () => {
    setLoader(true)
    GetEmployeeToRuleByEmployeeId(searchValue, callback => {
      setLoader(false)
      setApiData(callback)
      setcurrentPage(1)
      filterFunction(callback, 1)
    })
  }

  const handleclearsearch = () => {
    setSearchValue("")
    GetEmployeeToRuleFn()
  }

  const handleDeleteRule = (data) => {
    setconfirmPopup({ show: true, data: data })
  }

  const cancelLoanConfirm = (type) => {
    if (type == "yes") {
      setLoader(true)
      DeleteEmployeeToRuleById(confirmPopup?.data?.id, callback => {
        setLoader(false)
        if (callback?.responseCode !== 0) {
          setpopup({ show: true, popupStatus: "Rule Deleted succesfully" })
          setconfirmPopup({ show: false, data: {} })
          GetEmployeeToRuleFn()
        } else {
          setpopup({ show: true, popupStatus: "Error Deleting Rule" })
        }
        removePopup()
      })

    } else {
      setconfirmPopup({ show: false, data: {} })
    }
  }

  const closePopup = () => {
    setpopup({ show: false, popupStatus: "" })
  }
  const removePopup = () => {
    setTimeout(() => {
      closePopup()
    }, 5000)
  }

  const AgentHandler = (e) => {
    setagentType(e.target.value)
  }
  const RuleHandler = (e) => {
    setRuleType(e.target.value)
  }
  const typeHandler = (e) => {
    setEmployeestatus(e.target.value)
  }

  const SaveRule = () => {
    const data = {
      "empId": agentType,
      "ruleId": RuleType
    }
    setLoader(true)
    SaveEmployeetoRule(data, callback => {
      setLoader(false)
      if (callback && callback?.id) {
        setpopup({ show: true, popupStatus: "Rule Created succesfully" })
        GetEmployeeToRuleFn()
        setAddPopup(false)
        setagentType("")
        setRuleType("")
      } else {
        setpopup({ show: true, popupStatus: "Error Created Rule" })
      }
      removePopup()
    })
  }

  const getInfoData = (id) => {
    const obj = allcreatedRules && allcreatedRules?.length > 0 ? allcreatedRules?.filter((el) => el?.ruleId == id) : []
    console.log("obj", obj);
    return (
      <>
        <div>Application Status - {obj?.[0]?.applicationStatus || ""}</div>
        <div>Min Salary Criteria - {obj?.[0]?.minSalaryCriteria || ""}</div>
        <div>Max Salary Criteria - {obj?.[0]?.maxSalaryCriteria || ""}</div>
        <div>Min Value Criteria - {obj?.[0]?.minValueCriteria || ""}</div>
        <div>Max Value Criteria - {obj?.[0]?.maxValueCriteria || ""}</div>
        <div>Product Criteria - {String(obj?.[0]?.pincodeCriteria) || ""}</div>
      </>
    );
  }

  const AddEmployee = () => {
    setLoader(true)
    console.log("Employeestatus", Employeestatus, "employeeEmailId", employeeEmailId)
    saveAssignByStatusAPINew(Employeestatus, employeeEmailId, admin, "",callback=>{
      setLoader(false)
      console.log("call",callback)
    })
  }

  return (
    <>

      {
        loader ?
          <Loader />
          : ''
      }

      {
        confirmPopup?.show ?
          <ConfirmationPopup cancelLoanConfirm={cancelLoanConfirm} confirmationText={'Are You Sure, You Want to Delete this Assigned Rule'} customStyle={zindex} />
          : ''}

      {
        popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
          : ''}

      <div className="row" style={{ marginTop: '30px' }}>
        <div className="col-sm-2">
          <TextField fullWidth id="outlined-basic" label="Search by Email" variant="outlined"
            sx={{
              ".MuiInputLabel-formControl": {
                background: '#fff'
              }
            }}
            type='email'
            value={searchValue}
            onChange={(e) => handlesearchchange(e)}
          />
        </div>
        <div className="col-sm-3">
          <button className="btn btn-primary" style={{ marginBottom:'0',width: '100%', padding: '12.5px', maxWidth: '90px' }} disabled={searchValue?.length > 0 ? false : true} onClick={() => handlesearch()}>Filter</button>
          {
            searchValue?.length > 0 ?
              <button className="btn reset-btn" style={{ marginTop:'0',marginLeft: '10px',  width: '100%', background: '#fff',  borderRadius: '6px', padding: '10.5px', maxWidth: '90px' }} onClick={() => handleclearsearch()}>Clear Filter</button>
              : ''}
        </div>

        <div className="col-sm-3" style={{ float: 'right', textAlign: 'end',display:'flex' }}>
          <button className="btn btn-primary" style={{ width: '100%',  padding: '12.5px', marginRight: '10px' }} onClick={() => setAddUserPopup(true)}><AddCircleIcon style={{ marginBottom: '-3px' }} /> Add Employee</button>
          <button className="btn btn-primary" style={{ width: '100%',  padding: '12.5px' }} onClick={() => setAddPopup(true)}> Map Employee</button>
        </div>
      </div>
      <hr />

      <div className="row">
        <div className="col-xs-12">
          {
            FilterData && FilterData?.length > 0 ?
              <div>
                <div className='AssignmentRule-table'>
                  <table className='table-logs'>
                    <thead>
                      <tr>
                        <th>Agent Email Id</th>
                        <th>Assigned Rule Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        FilterData?.map((value, idx) => {
                          return (
                            <tr key={idx}>
                              <td className='text-center' style={{ padding: '10px' }}>{value?.empId || ""}</td>
                              <td className='text-center' style={{ padding: '10px' }}>
                                {value?.ruleId}&nbsp;
                                <CustomTooltip title={getInfoData(value?.ruleId) || 'NA'}>
                                  <InfoIcon style={{ marginLeft: '8px', cursor: 'pointer' }} />
                                </CustomTooltip>
                              </td>
                              <td className='text-center' style={{ padding: '10px' }}><DeleteIcon style={{ cursor: 'pointer' }} onClick={() => handleDeleteRule(value)} /></td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
                </div>
                <div style={{ marginTop: '10px', float: "right" }}>
                  <Pagination shape="rounded"
                    count={Math.ceil(apiData?.length / itemsPerPage)}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                  />
                </div>
              </div>
              : ''}
        </div>
      </div>

      {
        addPopup ?

          <div className="details-new background-blur" style={{ background: 'rgb(5 5 5 / 20%)', color: '#000' }}>
            <div className="edit-box " style={{ width: '40%', minHeight: '230px' }}>
              <div className="text-right" style={{ color: 'red' }}>
                <i className="fa fa-times" style={{ cursor: 'pointer' }} onClick={() => setAddPopup(false)}></i>
              </div>
              <h4><b>Map Rules</b></h4>
              <div className="row" style={{ marginTop: '35px' }}>
                <div className="col-sm-6 col-xs-12">
                  <BasicSelect
                    items={agentsList}
                    SelectedValue={agentType}
                    Changehandler={AgentHandler}
                    label={"Agent Email Id"}
                  />
                </div>
                <div className="col-sm-6 col-xs-12">
                  <BasicSelect
                    items={RulesList}
                    SelectedValue={RuleType}
                    Changehandler={RuleHandler}
                    label={"Rule Name"}
                  />
                </div>
              </div>
              <div className="text-center" style={{ marginTop: '30px' }}>
                <button className="btn" style={{ background: '#2B78FF', width: '100%', background: '#064254', borderColor: '#064254', color: '#fff', padding: '12.5px', maxWidth: '90px' }} disabled={agentType === "" || agentType == null || agentType == undefined || RuleType == null || RuleType == undefined || RuleType == "" ? true : false} onClick={() => SaveRule()}>Save</button>
              </div>
            </div>
          </div>
          : ""}
      {
        addUserPopup ?
          <>
         

            <div className="background-blur">

              <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{top:'15%', padding: '20px', borderRadius: '10px', width: '40%' }}>

                <div className="text-right" style={{ color: 'red' }}>
                  <i className="fa fa-times" style={{ cursor: 'pointer' }} onClick={() => setAddUserPopup(false)}></i>
                </div>
                <h4><b>Add Employees</b></h4>
                <div className="row" style={{ marginTop: '30px' }}>
                  <div className="col-sm-6 col-xs-12" >
                    <TextField fullWidth id="outlined-basic" label="Employee Email Id" variant="outlined"
                      sx={{
                        ".MuiInputLabel-formControl": {
                          background: '#fff'
                        },

                      }}
                      type='email'
                      value={employeeEmailId}
                      onChange={(e) => setemployeeEmailId(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-6 col-xs-12">
                    <BasicSelect
                      items={statusObj}
                      SelectedValue={Employeestatus}
                      Changehandler={typeHandler}
                      label={"Employee Status"}
                    />
                  </div>

                </div>

                <div className="text-center" style={{ marginTop: '30px' }}>
                  <button className="btn" style={{ background: '#2B78FF', width: '100%', background: '#064254', borderColor: '#064254', color: '#fff', padding: '12.5px', maxWidth: '90px' }} disabled={Employeestatus === "" || Employeestatus == null || Employeestatus == undefined || employeeEmailId == null || employeeEmailId == undefined || employeeEmailId == "" ? true : false} onClick={() => AddEmployee()}>Save</button>
                </div>

              </div>
            </div>
          </>
          : ""}
    </>
  )
}
